<div class="modal-header" id="yes-no-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.title }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col" [innerHTML]="model.message"></div>
    </div>
</div>
<div class="modal-footer">
    @if (model.cancelMessage) {
        <button class="btn btn-primary me-auto" (click)="onCancelClick()">
            {{ model.cancelMessage }}
        </button>
    }
    @if (model.noMessage) {
        <button class="btn btn-secondary customNoClass" (click)="onNoClicked()">
            {{ model.noMessage }}
        </button>
    }
    @if (model.showYes) {
        <button class="btn btn-primary" (click)="onYesClicked()">{{ model.yesMessage }}</button>
    }
</div>
